import React from 'react';

import { CustomTextField } from '../CustomTextField';
import { SocialMediaInputsContainer } from './styles';

export function SocialMediaInputs({
  instagramAccount,
  setInstagramAccount,
  facebookAccount,
  setFacebookAccount,
  linkedinAccount,
  setLinkedinAccount,
  tiktokAccount,
  setTiktokAccount,
}) {
  return (
    <SocialMediaInputsContainer>
      <CustomTextField
        prefix="instagram.com/"
        value={instagramAccount}
        setValue={setInstagramAccount}
      />
      <CustomTextField
        prefix="facebook.com/"
        value={facebookAccount}
        setValue={setFacebookAccount}
      />
      <CustomTextField
        prefix="linkedin.com/"
        value={linkedinAccount}
        setValue={setLinkedinAccount}
      />
      <CustomTextField
        prefix="tiktok.com/"
        value={tiktokAccount}
        setValue={setTiktokAccount}
      />
    </SocialMediaInputsContainer>
  );
}
